"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('data.factory', {
    getInstance: function (namespace, dataObject, tId) {
        var spaceArr = dataObject.split('.');
        if (!namespace_1.default.data[namespace])
            namespace_1.default.data[namespace] = {};
        var baseObject = namespace_1.default.data[namespace];
        var traversalObject = namespace_1.default.visual[namespace].data;
        for (var i = 0; i < spaceArr.length; i++) {
            if (!baseObject[spaceArr[i]])
                baseObject[spaceArr[i]] = {};
            baseObject = baseObject[spaceArr[i]];
            traversalObject = traversalObject[spaceArr[i]];
        }
        var factoryObject = traversalObject;
        if (tId != '') {
            if (!baseObject[tId]) {
                namespace_1.default.debug.showInfo(namespace + ': data.' + dataObject + '.' + tId + ' has been created.');
                baseObject[tId] = new factoryObject();
                baseObject[tId].namespace = namespace;
                baseObject[tId].init(tId);
            }
            else {
                namespace_1.default.debug.showInfo(namespace + ': data.' + dataObject + '.' + tId + ' already exists.');
            }
            return baseObject[tId];
        }
        else {
            if (namespace_1.default.utils.isEmptyObject(baseObject)) {
                namespace_1.default.debug.showInfo(namespace + ': data.' + dataObject + ' has been created.');
                namespace_1.default.utils.extend(baseObject, new factoryObject());
                baseObject.namespace = namespace;
                baseObject.init('');
            }
            else {
                namespace_1.default.debug.showInfo(namespace + ': data.' + dataObject + ' already exists.');
            }
            return baseObject;
        }
    }
});
